import React, { useMemo } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { getFormattedDate } from 'dateUtils';
import { getHasElementsInArray } from 'utils';
import { BrokerMessageType } from 'router/subrouters/DataRoom/models/DataRoomRfi';
import ChatIcon from 'icons/Chat.icon';
import RfiActivityEmptyState from '../RfiActivityEmptyState';
import { EMPTY_ARRAY } from 'data/global';

import './RfiActivityMessages.styles.scss';

type RfiActivityMessagesProps = {
  className?: string;
  messages: BrokerMessageType[];
};

const RfiActivityMessages: React.FC<RfiActivityMessagesProps> = ({
  className,
  messages,
}) => {
  const { t } = useTranslation();

  const classes = classNames('rfi-activity-messages', className);

  const sortedMessages = useMemo(
    () =>
      [...(messages || EMPTY_ARRAY)].sort(
        (a, b) => +new Date(b.addedAt) - +new Date(a.addedAt),
      ),
    [messages],
  );

  if (!getHasElementsInArray(sortedMessages))
    return (
      <RfiActivityEmptyState
        Icon={ChatIcon}
        title={t('activityNoMessagesYetTitle')}
        description={t('activityNoMessagesYetDescription')}
      />
    );

  return (
    <ul className={classes}>
      {sortedMessages.map(({ content, addedAt, dataRoomRFIFileUploader }) => (
        <li
          key={`${dataRoomRFIFileUploader?.email}-${+new Date(addedAt)}`}
          className="rfi-activity-messages__card"
        >
          <p className="rfi-activity-messages__card__meta">
            <span className="rfi-activity-messages__card__meta__email">
              {dataRoomRFIFileUploader?.email}
            </span>
            <span className="rfi-activity-messages__card__meta__date">
              {getFormattedDate(addedAt)}
            </span>
          </p>

          <p className="rfi-activity-messages__card__content">{content}</p>
        </li>
      ))}
    </ul>
  );
};

export default RfiActivityMessages;
